<template>
  <div class="noHave" >
    <img src="../../assets/img/pic_ordermiss.png" alt />
    <p>{{text}}</p>
  </div>
</template>

<script>
export default {
  name: "Lack",
  props: {
    // lists: [] //数组类型
    text:{
      default:'暂无相关纪录',
      type:String
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.noHave {
  img {
    width: 160px;
    height: 160px;
    margin-top: 147px;
  }
  p {
    font-size: 17px;
    color: #d61a1a;
    margin: 0;
  }
}
</style>

